export const OPAU_CLIENT_GROUP_NAME = 'TELECARE_OPAU'

export enum SSO_CLIENT {
  TELECARE = 'TELECARE',
  TELECARE_AUTH0 = 'TELECARE_AUTH0',
  TELECARE_JC = 'TELECARE_JC',
  TELECARE_OAM = 'TELECARE_OAM',
  TELECARE_OPAU_SCMC = 'TELECARE_OPAU_SCMC',
  TELECARE_OPAU_CHHHS = 'TELECARE_OPAU_CHHHS',
  TELECARE_OPAU_RHC = 'TELECARE_OPAU_RHC',
  TELECARE_OPAU_WBHHS = 'TELECARE_OPAU_WBHHS',
  TELECARE_OPAU_CQLD = 'TELECARE_OPAU_CQLD',
  TELECARE_OPAU_MNHHS = 'TELECARE_OPAU_MNHHS',
  HDA = 'HDA',
  CONSULTMED = 'CONSULTMED',
  SLHD = 'SLHD',
  EVERLAB = 'EVERLAB',
  EVERLAB_JC = 'EVERLAB_JC',
  TELADOC_SOLO = 'TELADOC_SOLO',
}

export enum SSO_PROVIDER_PLATFORM {
  AUTH0 = 'AUTH0',
  COGNITO = 'COGNITO',
  AZURE_AD = 'AZURE_AD',
  OAM = 'OAM',
  JUMP_CLOUD = 'JUMP_CLOUD',
  CLOUDFLARE = 'CLOUDFLARE',
}

export enum SSO_PROVIDER_TYPE {
  SAML = 'SAML',
  OIDC = 'OIDC',
}

export interface SSOClientConfig {
  clientName: SSO_CLIENT
  identityProvider?: string
  clientId?: string
  oauthScopes?: string[]
  orgId?: string
  clinicId?: string
  forcePhoneNumber?: string
  prescriberOnly?: boolean
  providerId?: string
  providerPlatform?: SSO_PROVIDER_PLATFORM
  providerType?: SSO_PROVIDER_TYPE
}

export interface ClientSSOContext {
  externalPatientFetchId?: string
  clientName?: SSO_CLIENT
  providerId?: string
  referralId?: string
  metadata?: Record<string, string>
  providerPlatform?: SSO_PROVIDER_PLATFORM
  providerType?: SSO_PROVIDER_TYPE
}
